module.exports = __webpack_public_path__ + "static/real-arm-design-5c56ca194819be7da643517dbea6c85f.png";